import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const PILLARS = ["Artificial Intelligence", "Digital Assets", "Blockchain Infrastructure", "Financial Technology"];

export default function About() {
  return (
    <section id="about" className="relative py-24 sm:py-32 border-t border-white/[0.06]" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
          <SectionHeading
            chapter="Chapter 08"
            kicker="The Vision"
            title="Building the Financial Infrastructure of Tomorrow."
          />
          <Reveal delay={0.15}>
            <p className="text-base sm:text-lg leading-relaxed text-[#99A1AF]">
              Winter Protocol is being built with a long-term vision to combine artificial intelligence,
              digital assets, blockchain infrastructure and financial technology into one expanding ecosystem.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map((p, i) => (
            <Reveal key={p} delay={i * 0.06} className="h-full">
              <div className="flex h-full flex-col justify-between gap-10 bg-[#0B0B0F] p-7" data-testid={`about-pillar-${i + 1}`}>
                <span className="font-mono text-xs text-[#3A3F4A]">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-lg font-semibold text-white">{p}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
